import { GameEvent } from "./GameEvent.js";


export class RollGameEvent extends GameEvent {
    constructor() {
        super("roll");
    }
}
